import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Api from 'app/helpers/api';
import App from 'app/helpers/app';
import { ExcelService } from 'app/helpers/excel.service';
import Me from 'app/helpers/me';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-relatorios-unificado',
  templateUrl: './relatorios-unificado.component.html',
  styleUrls: ['./relatorios-unificado.component.scss']
})
export class RelatoriosUnificadoComponent implements OnInit {
  apiCall = this.api.new().silent();
  idCidade = null;
  cidade = null;
  
  // Dados para exportação
  servidoresAtivos = [];
  servidoresInativos = [];
  servidoresPensionistas = [];
  
  // Campos disponíveis para cada tipo de relatório
  camposSPREVAtivos = [
    { id: 'ANO', label: 'ANO', checked: true, exemplo: '2025' },
    { id: 'MÊS', label: 'MÊS', checked: true, exemplo: 'MAIO' },
    { id: 'CO_IBGE', label: 'CO_IBGE', checked: true, exemplo: '3550308' },
    { id: 'NOME_DO_ENTE', label: 'NOME_DO_ENTE', checked: true, exemplo: 'PREFEITURA MUNICIPAL DE SÃO PAULO' },
    { id: 'SIGLA_ESTADO', label: 'SIGLA_ESTADO', checked: true, exemplo: 'SP' },
    { id: 'COMPOSIÇÃO DA MASSA (A)', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true, exemplo: 'ATIVO' },
    { id: 'TIPO DO FUNDO (B)', label: 'TIPO DO FUNDO (B)', checked: true, exemplo: 'RPPS' },
    { id: 'CNPJ', label: 'CNPJ', checked: true, exemplo: '46.392.076/0001-83' },
    { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true, exemplo: 'SECRETARIA MUNICIPAL DE EDUCAÇÃO' },
    { id: 'PODER', label: 'PODER', checked: true, exemplo: 'EXECUTIVO' },
    { id: 'TIPO', label: 'TIPO', checked: true, exemplo: 'AUTARQUIA' },
    { id: 'A - POPULAÇÃO COBERTA', label: 'A - POPULAÇÃO COBERTA', checked: true, exemplo: 'Ativos' },
    { id: 'B- POPULAÇÃO COBERTA', label: 'B- POPULAÇÃO COBERTA', checked: true, exemplo: '21' },
    { id: 'C - POPULAÇÃO COBERTA', label: 'C - POPULAÇÃO COBERTA', checked: true, exemplo: 'MILITARES' },
    { id: 'Matrícula', label: 'Matrícula', checked: true, exemplo: '12345' },
    { id: 'CPF', label: 'CPF', checked: true, exemplo: '123.456.789-00' },
    { id: 'PIS-PASEP', label: 'PIS-PASEP', checked: true, exemplo: '123.45678.90-1' },
    { id: 'SEXO', label: 'SEXO', checked: true, exemplo: 'M' },
    { id: 'ESTADO CIVIL', label: 'ESTADO CIVIL', checked: true, exemplo: 'SOLTEIRO' },
    { id: 'DATA DE NASCIMENTO', label: 'DATA DE NASCIMENTO', checked: true, exemplo: '01/01/1980' },
    { id: 'COD SITUAÇÃO FUNCIONAL', label: 'COD SITUAÇÃO FUNCIONAL', checked: true, exemplo: '1' },
    { id: 'TIPO DE VÍNCULO', label: 'TIPO DE VÍNCULO', checked: true, exemplo: 'CONCURSADO' },
    { id: 'DATA DE INGRESSO NO SERV_PUBLICO', label: 'DATA DE INGRESSO NO SERV_PUBLICO', checked: true, exemplo: '01/01/2010' },
    { id: 'DATA DE INGRESSO NO ENTE', label: 'DATA DE INGRESSO NO ENTE', checked: true, exemplo: '01/01/2010' },
    { id: 'DATA DE INGRESSO NA CARREIRA ATUAL', label: 'DATA DE INGRESSO NA CARREIRA ATUAL', checked: true, exemplo: '01/01/2010' },
    { id: 'IDENTIFICAÇÃO DA CARREIRA ATUAL', label: 'IDENTIFICAÇÃO DA CARREIRA ATUAL', checked: true, exemplo: 'PROFESSOR' },
    { id: 'DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL', label: 'DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL', checked: true, exemplo: '01/01/2010' },
    { id: 'IDENTIFICAÇÃO DO CARGO ATUAL', label: 'IDENTIFICAÇÃO DO CARGO ATUAL', checked: true, exemplo: 'PROFESSOR I' },
    { id: 'BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', label: 'BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', checked: true, exemplo: '5000.00' },
    { id: 'REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO', label: 'REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO', checked: true, exemplo: '6000.00' },
    { id: 'CONTRIBUIÇÃO MENSAL', label: 'CONTRIBUIÇÃO MENSAL', checked: true, exemplo: '500.00' },
    { id: 'PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', label: 'PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', checked: true, exemplo: '4000.00' },
    { id: 'TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS', label: 'TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS', checked: true, exemplo: '2' },
    { id: 'NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO', label: 'NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO', checked: true, exemplo: '2' },
    { id: 'DATA DE NASCIMENTO DO CÔNJUGE OU COMPANHEIRO(A)', label: 'DATA DE NASCIMENTO DO CÔNJUGE OU COMPANHEIRO(A)', checked: true, exemplo: '01/01/1985' },
    { id: 'CONDIÇÃO DO CÔNJUGE', label: 'CONDIÇÃO DO CÔNJUGE', checked: true, exemplo: '1' },
    { id: 'DATA DE NASCIMENTO DO DEPENDENTE 2', label: 'DATA DE NASCIMENTO DO DEPENDENTE 2', checked: true, exemplo: '01/01/2010' },
    { id: 'CONDIÇÃO DO DEPENDENTE 2', label: 'CONDIÇÃO DO DEPENDENTE 2', checked: true, exemplo: '1' },
    { id: 'DATA DE NASCIMENTO DO DEPENDENTE 3', label: 'DATA DE NASCIMENTO DO DEPENDENTE 3', checked: true, exemplo: '01/01/2015' },
    { id: 'CONDIÇÃO DO DEPENDENTE 3', label: 'CONDIÇÃO DO DEPENDENTE 3', checked: true, exemplo: '1' },
    { id: 'SEGURADO EM ABONO DE PERMANÊNCIA ', label: 'SEGURADO EM ABONO DE PERMANÊNCIA ', checked: true, exemplo: 'NÃO' },
    { id: 'DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO', label: 'DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO', checked: true, exemplo: '' },
    { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true, exemplo: '' },
    { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true, exemplo: '' },
    { id: 'RECENSEADO', label: 'RECENSEADO', checked: true, exemplo: 'Sim' }
  ];

  camposSPREVInativos = [
    { id: 'ANO', label: 'ANO', checked: true, exemplo: '2025' },
    { id: 'MÊS', label: 'MÊS', checked: true, exemplo: 'MAIO' },
    { id: 'CO_IBGE', label: 'CO_IBGE', checked: true, exemplo: '3550308' },
    { id: 'NOME_DO_ENT', label: 'NOME_DO_ENT', checked: true, exemplo: 'PREFEITURA MUNICIPAL DE SÃO PAULO' },
    { id: 'SIGLA_ESTADO', label: 'SIGLA_ESTADO', checked: true, exemplo: 'SP' },
    { id: 'COMPOSIÇÃO DA MASSA (A)', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true, exemplo: '1' },
    { id: 'TIPO DE FUNDO (B)', label: 'TIPO DE FUNDO (B)', checked: true, exemplo: 'RPPS' },
    { id: 'CNPJ', label: 'CNPJ', checked: true, exemplo: '46.392.076/0001-83' },
    { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true, exemplo: 'SECRETARIA MUNICIPAL DE EDUCAÇÃO' },
    { id: 'PODER', label: 'PODER', checked: true, exemplo: 'EXECUTIVO' },
    { id: 'CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)', label: 'CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)', checked: true, exemplo: '1' },
    { id: 'TIPO_AUTARQUIA', label: 'TIPO_AUTARQUIA', checked: true, exemplo: 'AUTARQUIA' },
    { id: 'CO_TIPO_POPULACAO', label: 'CO_TIPO_POPULACAO', checked: true, exemplo: '4' },
    { id: 'TIPO_CARGO', label: 'TIPO_CARGO', checked: true, exemplo: 'EFETIVO' },
    { id: 'CO_TIPO_APOSENTADORIA', label: 'CO_TIPO_APOSENTADORIA', checked: true, exemplo: 'IDADE' },
    { id: 'MATRÍCULA', label: 'MATRÍCULA', checked: true, exemplo: '12345' },
    { id: 'CPF', label: 'CPF', checked: true, exemplo: '123.456.789-00' },
    { id: 'PIS-PASEP', label: 'PIS-PASEP', checked: true, exemplo: '123.45678.90-1' },
    { id: 'SEXO DO APOSENTADO', label: 'SEXO DO APOSENTADO', checked: true, exemplo: 'M' },
    { id: 'ESTADO CIVIL', label: 'ESTADO CIVIL', checked: true, exemplo: 'SOLTEIRO' },
    { id: 'DATA DE NASCIMENTO', label: 'DATA DE NASCIMENTO', checked: true, exemplo: '01/01/1980' },
    { id: 'DT_ING_SERV_PUB', label: 'DT_ING_SERV_PUB', checked: true, exemplo: '01/01/2010' },
    { id: 'DATA DE INGRESSO NO ENTE', label: 'DATA DE INGRESSO NO ENTE', checked: true, exemplo: '01/01/2010' },
    { id: 'DT_INICIO_APOSENTADORIA', label: 'DT_INICIO_APOSENTADORIA', checked: true, exemplo: '01/01/2020' },
    { id: 'VL_APOSENTADORIA', label: 'VL_APOSENTADORIA', checked: true, exemplo: '5000.00' },
    { id: 'VL_CONTRIBUICAO', label: 'VL_CONTRIBUICAO', checked: true, exemplo: '500.00' },
    { id: 'VL_COMPENS_PREVID', label: 'VL_COMPENS_PREVID', checked: true, exemplo: '' },
    { id: 'IN_PARID_SERV', label: 'IN_PARID_SERV', checked: true, exemplo: 'NÃO' },
    { id: 'CO_CONDICAO_APOSENTADO', label: 'CO_CONDICAO_APOSENTADO', checked: true, exemplo: 'NORMAL' },
    { id: 'NU_TEMPO_RGPS_MUN', label: 'NU_TEMPO_RGPS_MUN', checked: true, exemplo: '2' },
    { id: 'NU_TEMPO_RPPS', label: 'NU_TEMPO_RPPS', checked: true, exemplo: '10' },
    { id: 'NU_DEPENDENTES', label: 'NU_DEPENDENTES', checked: true, exemplo: '2' },
    { id: 'DATA DE NASCIMENTO DO CÔNJUGE', label: 'DATA DE NASCIMENTO DO CÔNJUGE', checked: true, exemplo: '01/01/1985' },
    { id: 'CONDIÇÃO DO CÔNJUGE', label: 'CONDIÇÃO DO CÔNJUGE', checked: true, exemplo: '1' },
    { id: 'DATA DE NASCIMENTO DO DEPENDENTE 2', label: 'DATA DE NASCIMENTO DO DEPENDENTE 2', checked: true, exemplo: '01/01/2010' },
    { id: 'CONDIÇÃO DO DEPENDENTE 2', label: 'CONDIÇÃO DO DEPENDENTE 2', checked: true, exemplo: '1' },
    { id: 'DATA DE NASCIMENTO DO DEPENDENTE 3', label: 'DATA DE NASCIMENTO DO DEPENDENTE 3', checked: true, exemplo: '01/01/2015' },
    { id: 'CONDIÇÃO DO DEPENDENTE 3', label: 'CONDIÇÃO DO DEPENDENTE 3', checked: true, exemplo: '1' },
    { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true, exemplo: '' },
    { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true, exemplo: '' },
    { id: 'RECENSEADO', label: 'RECENSEADO', checked: true, exemplo: 'Sim' }
  ];

  camposSPREVPensionistas = [
    { id: 'ANO', label: 'ANO', checked: true, exemplo: '2025' },
    { id: 'MÊS', label: 'MÊS', checked: true, exemplo: 'MAIO' },
    { id: 'CO_IBGE', label: 'CO_IBGE', checked: true, exemplo: '3550308' },
    { id: 'NOME_DO_ENTE', label: 'NOME_DO_ENTE', checked: true, exemplo: 'PREFEITURA MUNICIPAL DE SÃO PAULO' },
    { id: 'SG_UF', label: 'SIGLA_ESTADO', checked: true, exemplo: 'SP' },
    { id: 'CO_COMP_MASSA', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_FUNDO', label: 'TIPO DE FUNDO (B)', checked: true, exemplo: 'RPPS' },
    { id: 'CNPJ', label: 'CNPJ', checked: true, exemplo: '46.392.076/0001-83' },
    { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true, exemplo: 'SECRETARIA MUNICIPAL DE EDUCAÇÃO' },
    { id: 'CO_PODER (CÓDIGO DO PODER)', label: 'CO_PODER (CÓDIGO DO PODER)', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)', label: 'CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_INSTITUIDOR (CÓDIGO DO TIPO DE INSTITUIDOR)', label: 'CO_TIPO_INSTITUIDOR (CÓDIGO DO TIPO DE INSTITUIDOR)', checked: true, exemplo: '1' },
    { id: 'ID MATRICULA INSTITUIDOR', label: 'ID MATRICULA INSTITUIDOR', checked: true, exemplo: '12345' },
    { id: 'INSTITUIDOR CPF', label: 'INSTITUIDOR CPF', checked: true, exemplo: '123.456.789-00' },
    { id: 'INSTITUIDOR PIS PASEP', label: 'INSTITUIDOR PIS PASEP', checked: true, exemplo: '123.45678.90-1' },
    { id: 'SEXO INSTITUIDOR', label: 'SEXO INSTITUIDOR', checked: true, exemplo: 'M' },
    { id: 'DT_NASC_INSTITUIDOR', label: 'DT_NASC_INSTITUIDOR', checked: true, exemplo: '01/01/1980' },
    { id: 'DT_OBITO_INSTITUIDOR', label: 'DT_OBITO_INSTITUIDOR', checked: true, exemplo: '01/01/2020' },
    { id: 'MATRICULA_PENSIONISTA', label: 'MATRICULA_PENSIONISTA', checked: true, exemplo: '67890' },
    { id: 'CPF_PENSIONISTA', label: 'CPF_PENSIONISTA', checked: true, exemplo: '987.654.321-00' },
    { id: 'SEXO', label: 'SEXO', checked: true, exemplo: 'F' },
    { id: 'DT_NASC_PENSIONISTA', label: 'DT_NASC_PENSIONISTA', checked: true, exemplo: '01/01/1985' },
    { id: 'RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR', label: 'RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR', checked: true, exemplo: 'CÔNJUGE' },
    { id: 'DATA INICIO PENSAO', label: 'DATA INICIO PENSAO', checked: true, exemplo: '01/01/2020' },
    { id: 'VALOR BENEF PENSAO', label: 'VALOR BENEF PENSAO', checked: true, exemplo: '2500.00' },
    { id: 'VALOR TOTAL DA PENSÃO', label: 'VALOR TOTAL DA PENSÃO', checked: true, exemplo: '2500.00' },
    { id: 'VL_PCT_QUOTA', label: 'VL_PCT_QUOTA', checked: true, exemplo: '50' },
    { id: 'VALOR CONTRIBUICAO', label: 'VALOR CONTRIBUICAO', checked: true, exemplo: '250.00' },
    { id: 'VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA', label: 'VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA', checked: true, exemplo: '' },
    { id: 'PARIDADE', label: 'PARIDADE', checked: true, exemplo: 'NÃO' },
    { id: 'CONDIÇÃO DO PENSIONISTA', label: 'CONDIÇÃO DO PENSIONISTA', checked: true, exemplo: 'NORMAL' },
    { id: 'DURAÇÃO DO BENEFÍCIO', label: 'DURAÇÃO DO BENEFÍCIO', checked: true, exemplo: 'VITALÍCIA' },
    { id: 'TEMPO DURAÇÃO DO BENEFÍCIO', label: 'TEMPO DURAÇÃO DO BENEFÍCIO', checked: true, exemplo: '' },
    { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true, exemplo: '' },
    { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true, exemplo: '' },
    { id: 'RECENSEADO', label: 'RECENSEADO', checked: true, exemplo: 'Sim' }
  ];

  // Campos para relatórios dinâmicos (baseados no componente relatorios-dinamico)
  camposServidoresAtivos = [];
  camposServidoresInativos = [];
  camposServidoresPensionistas = [];

  // Campos para outros relatórios (baseados nos componentes existentes)
  camposServidores = [
    { id: 'NU_ANO', label: 'NU_ANO', checked: true, exemplo: '2025' },
    { id: 'CO_IBGE', label: 'CO_IBGE', checked: true, exemplo: '3550308' },
    { id: 'NO_ENTE', label: 'NO_ENTE', checked: true, exemplo: 'PREFEITURA MUNICIPAL DE SÃO PAULO' },
    { id: 'SG_UF', label: 'SG_UF', checked: true, exemplo: 'SP' },
    { id: 'CO_COMP_MASSA', label: 'CO_COMP_MASSA', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_FUNDO', label: 'CO_TIPO_FUNDO', checked: true, exemplo: 'RPPS' },
    { id: 'CNPJ_ORGAO', label: 'CNPJ_ORGAO', checked: true, exemplo: '46.392.076/0001-83' },
    { id: 'NO_ORGAO', label: 'NO_ORGAO', checked: true, exemplo: 'SECRETARIA MUNICIPAL DE EDUCAÇÃO' },
    { id: 'CO_PODER', label: 'CO_PODER', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_PODER', label: 'CO_TIPO_PODER', checked: true, exemplo: '1' },
    { id: 'CO_TIPO_INSTITUIDOR', label: 'CO_TIPO_INSTITUIDOR', checked: true, exemplo: '1' },
    { id: 'ID_INSTITUIDOR_MATRICULA', label: 'ID_INSTITUIDOR_MATRICULA', checked: true, exemplo: '12345' },
    { id: 'ID_INSTITUIDOR_CPF', label: 'ID_INSTITUIDOR_CPF', checked: true, exemplo: '123.456.789-00' },
    { id: 'ID_INSTITUIDOR_PIS_PASEP', label: 'ID_INSTITUIDOR_PIS_PASEP', checked: true, exemplo: '123.45678.90-1' },
    { id: 'ID_PENSIONISTA_CPF', label: 'ID_PENSIONISTA_CPF', checked: true, exemplo: '987.654.321-00' },
    { id: 'CO_SEXO_PENSIONISTA', label: 'CO_SEXO_PENSIONISTA', checked: true, exemplo: 'M' },
    { id: 'DT_NASC_PENSIONISTA', label: 'DT_NASC_PENSIONISTA', checked: true, exemplo: '01/01/1985' },
    { id: 'DT_INICIO_PENSAO', label: 'DT_INICIO_PENSAO', checked: true, exemplo: '01/01/2020' },
    { id: 'VL_BENEF_PENSAO', label: 'VL_BENEF_PENSAO', checked: true, exemplo: '2500.00' },
    { id: 'VL_CONTRIBUICAO', label: 'VL_CONTRIBUICAO', checked: true, exemplo: '250.00' },
    { id: 'VL_COMPENS_PREVID', label: 'VL_COMPENS_PREVID', checked: true, exemplo: '' },
    { id: 'IN_PARID_SERV', label: 'IN_PARID_SERV', checked: true, exemplo: 'NÃO' },
    { id: 'CO_CONDICAO', label: 'CO_CONDICAO', checked: true, exemplo: 'NORMAL' },
    { id: 'CO_DURACAO', label: 'CO_DURACAO', checked: true, exemplo: 'VITALÍCIA' }
  ];

  camposTempoServico = [
    { id: 'NOME_SERVIDOR', label: 'NOME_SERVIDOR', checked: true, exemplo: 'João Silva' },
    { id: 'CPF_CNPJ_EMPREGADOR', label: 'CPF_CNPJ_EMPREGADOR', checked: true, exemplo: '12.345.678/0001-90' },
    { id: 'DATA_INICIO', label: 'DATA_INICIO', checked: true, exemplo: '01/01/2010' },
    { id: 'DATA_FIM', label: 'DATA_FIM', checked: true, exemplo: '31/12/2015' },
    { id: 'TEMPO_BRUTO', label: 'TEMPO_BRUTO', checked: true, exemplo: '5 anos' },
    { id: 'NUMERO_CERTIDAO', label: 'NUMERO_CERTIDAO', checked: true, exemplo: '123456' },
    { id: 'DATA_CERTIDAO', label: 'DATA_CERTIDAO', checked: true, exemplo: '01/01/2016' }
  ];

  camposAtendimentos = [
    { id: 'nome', label: 'Nome', checked: true, exemplo: 'LUCIANO DA SILVA PEREIRA' },
    { id: 'atendimento_realizado', label: 'Atendimento Realizado', checked: true, exemplo: 'sim' },
    { id: 'data_inicio_atendimento', label: 'Data Início Atendimento', checked: true, exemplo: '16/12/2024' },
    { id: 'hora_inicio_atendimento', label: 'Hora Início Atendimento', checked: true, exemplo: '09:12:27' },
    { id: 'data_fim_atendimento', label: 'Data Fim Atendimento', checked: true, exemplo: '29/11/2024' },
    { id: 'hora_fim_atendimento', label: 'Hora Fim Atendimento', checked: true, exemplo: '17:11:59' },
    { id: 'status', label: 'Status', checked: true, exemplo: 'Ativo' },
    { id: 'cpf', label: 'CPF', checked: true, exemplo: '93162227020' },
    { id: 'matricula', label: 'Matrícula', checked: true, exemplo: '4335214' },
    { id: 'cidade', label: 'Cidade', checked: true, exemplo: 'Charqueadas' },
    { id: 'local_trabalho', label: 'Local de Trabalho', checked: true, exemplo: 'SAMU' }
  ];

  camposPendencias = [
    { id: 'NOME', label: 'NOME', checked: true, exemplo: 'João Silva' },
    { id: 'STATUS', label: 'STATUS', checked: true, exemplo: 'Ativo' },
    { id: 'PENDÊNCIA', label: 'PENDÊNCIA', checked: true, exemplo: 'Documento em falta' },
    { id: 'OBSERVAÇÃO', label: 'OBSERVAÇÃO', checked: true, exemplo: 'Aguardando envio' }
  ];

  // Removido controle manual de tabs - usando ngb-tabset
  
  // Controle de seleção de relatórios SPREV
  incluirArquivo = true;
  exportarAtivos = true;
  exportarInativos = true;
  exportarPensionistas = true;

  constructor(
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private me: Me,
    private excelService: ExcelService,
    private app: App,
    private http: HttpClient,
    private api: Api
  ) { }

  ngOnInit(): void {
    const self = this;
    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    self.idCidade = json.user.cidade;
    
    // Inicializar campos dinâmicos (baseados no relatorios-dinamico)
    this.inicializarCamposDinamicos();
    
    // Carregar dados da cidade
    this.loadCidadeData();
  }

  inicializarCamposDinamicos() {
    // Campos Ativos (mesmos do relatorios-dinamico)
    this.camposServidoresAtivos = [
      { id: 'NOME', label: 'NOME', checked: true },
      { id: 'ANO', label: 'ANO', checked: true },
      { id: 'MÊS', label: 'MÊS', checked: true },
      { id: 'CO_IBGE', label: 'CO_IBGE', checked: true },
      { id: 'NOME_DO_ENTE', label: 'NOME_DO_ENTE', checked: true },
      { id: 'SIGLA_ESTADO', label: 'SIGLA_ESTADO', checked: true },
      { id: 'COMPOSIÇÃO DA MASSA (A)', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true },
      { id: 'TIPO DO FUNDO (B)', label: 'TIPO DO FUNDO (B)', checked: true },
      { id: 'CNPJ', label: 'CNPJ', checked: true },
      { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true },
      { id: 'PODER', label: 'PODER', checked: true },
      { id: 'TIPO', label: 'TIPO', checked: true },
      { id: 'A - POPULAÇÃO COBERTA', label: 'A - POPULAÇÃO COBERTA', checked: true },
      { id: 'B- POPULAÇÃO COBERTA', label: 'B- POPULAÇÃO COBERTA', checked: true },
      { id: 'C - POPULAÇÃO COBERTA', label: 'C - POPULAÇÃO COBERTA', checked: true },
      { id: 'MATRÍCULA', label: 'MATRÍCULA', checked: true },
      { id: 'CPF', label: 'CPF', checked: true },
      { id: 'PASEP', label: 'PIS-PASEP', checked: true },
      { id: 'SEXO', label: 'SEXO', checked: true },
      { id: 'ESTADO CIVIL', label: 'ESTADO CIVIL', checked: true },
      { id: 'DATA DE NASCIMENTO', label: 'DATA DE NASCIMENTO', checked: true },
      { id: 'COD SITUAÇÃO FUNCIONA', label: 'COD SITUAÇÃO FUNCIONAL', checked: true },
      { id: 'TIPO DE VÍNCULO', label: 'TIPO DE VÍNCULO', checked: true },
      { id: 'DATA DE INGRESSO NO SERV_PUBLICO', label: 'DATA DE INGRESSO NO SERV_PUBLICO', checked: true },
      { id: 'DATA DE INGRESSO NO ENTE', label: 'DATA DE INGRESSO NO ENTE', checked: true },
      { id: 'DATA DE INGRESSO NA CARREIRA ATUAL', label: 'DATA DE INGRESSO NA CARREIRA ATUAL', checked: true },
      { id: 'IDENTIFICAÇÃO DA CARREIRA ATUAL', label: 'IDENTIFICAÇÃO DA CARREIRA ATUAL', checked: true },
      { id: 'DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL', label: 'DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL', checked: true },
      { id: 'IDENTIFICAÇÃO DO CARGO ATUAL', label: 'IDENTIFICAÇÃO DO CARGO ATUAL', checked: true },
      { id: 'BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', label: 'BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', checked: true },
      { id: 'REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO', label: 'REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO', checked: true },
      { id: 'CONTRIBUIÇÃO MENSAL', label: 'CONTRIBUIÇÃO MENSAL', checked: true },
      { id: 'PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', label: 'PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO', checked: true },
      { id: 'TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS', label: 'TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS', checked: true },
      { id: 'NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO', label: 'NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO', checked: true },
      { id: 'CONDIÇÃO DO CÔNJUGE', label: 'CONDIÇÃO DO CÔNJUGE', checked: true },
      { id: 'DATA DE NASCIMENTO DO DEPENDENTE 2', label: 'DATA DE NASCIMENTO DO DEPENDENTE 2', checked: true },
      { id: 'CONDIÇÃO DO DEPENDENTE 2', label: 'CONDIÇÃO DO DEPENDENTE 2', checked: true },
      { id: 'DATA DE NASCIMENTO DO DEPENDENTE 3', label: 'DATA DE NASCIMENTO DO DEPENDENTE 3', checked: true },
      { id: 'CONDIÇÃO DO DEPENDENTE 3', label: 'CONDIÇÃO DO DEPENDENTE 3', checked: true },
      { id: 'SEGURADO EM ABONO DE PERMANÊNCIA', label: 'SEGURADO EM ABONO DE PERMANÊNCIA', checked: true },
      { id: 'DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO', label: 'DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO', checked: true },
      { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true },
      { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true },
    ];

    // Campos Pensionistas (mesmos do relatorios-dinamico)
    this.camposServidoresPensionistas = [
      { id: 'NOME', label: 'NOME', checked: true },
      { id: 'ANO', label: 'ANO', checked: true },
      { id: 'MÊS', label: 'MÊS', checked: true },
      { id: 'CO_IBGE', label: 'CO_IBGE', checked: true },
      { id: 'NOME_DO_ENTE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true },
      { id: 'SG_UF', label: 'SIGLA_ESTADO', checked: true },
      { id: 'CO_COMP_MASSA', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true },
      { id: 'CO_TIPO_FUNDO', label: 'TIPO DE FUNDO (B)', checked: true },
      { id: 'CNPJ', label: 'CNPJ', checked: true },
      { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true },
      { id: 'CO_PODER', label: 'CO_PODER (CÓDIGO DO PODER)', checked: true },
      { id: 'CO_TIPO_PODER', label: 'CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)', checked: true },
      { id: 'CO_TIPO_INSTITUIDOR', label: 'CO_TIPO_INSTITUIDOR (CÓDIGO DO TIPO DE INSTITUIDOR)', checked: true },
      { id: 'ID MATRICULA INSTITUIDOR', label: 'ID MATRICULA INSTITUIDOR', checked: true },
      { id: 'INSTITUIDOR CPF', label: 'INSTITUIDOR CPF', checked: true },
      { id: 'INSTITUIDOR PIS PASEP', label: 'INSTITUIDOR PIS PASEP', checked: true },
      { id: 'SEXO INSTITUIDOR', label: 'SEXO INSTITUIDOR', checked: true },
      { id: 'DT_NASC_INSTITUIDOR', label: 'DT_NASC_INSTITUIDOR', checked: true },
      { id: 'DT_OBITO_INSTITUIDOR', label: 'DT_OBITO_INSTITUIDOR', checked: true },
      { id: 'MATRICULA_PENSIONISTA', label: 'MATRICULA_PENSIONISTA', checked: true },
      { id: 'CPF_PENSIONISTA', label: 'CPF_PENSIONISTA', checked: true },
      { id: 'SEXO', label: 'SEXO', checked: true },
      { id: 'DT_NASC_PENSIONISTA', label: 'DT_NASC_PENSIONISTA', checked: true },
      { id: 'RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR', label: 'RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR', checked: true },
      { id: 'DATA INICIO PENSAO', label: 'DATA INICIO PENSAO', checked: true },
      { id: 'VALOR BENEF PENSAO', label: 'VALOR BENEF PENSAO', checked: true },
      { id: 'VALOR TOTAL DA PENSÃO', label: 'VALOR TOTAL DA PENSÃO', checked: true },
      { id: 'VL_PCT_QUOTA', label: 'VL_PCT_QUOTA', checked: true },
      { id: 'VALOR CONTRIBUICAO', label: 'VALOR CONTRIBUICAO', checked: true },
      { id: 'VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA', label: 'VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA', checked: true },
      { id: 'PARIDADE', label: 'PARIDADE', checked: true },
      { id: 'CONDIÇÃO DO PENSIONISTA', label: 'CONDIÇÃO DO PENSIONISTA', checked: true },
      { id: 'DURAÇÃO DO BENEFÍCIO', label: 'DURAÇÃO DO BENEFÍCIO', checked: true },
      { id: 'TEMPO DURAÇÃO DO BENEFÍCIO', label: 'TEMPO DURAÇÃO DO BENEFÍCIO', checked: true },
      { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true },
      { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true }
    ];

    // Campos Inativos (mesmos do relatorios-dinamico)
    this.camposServidoresInativos = [
      { id: 'NOME', label: 'NOME', checked: true },
      { id: 'ANO', label: 'ANO', checked: true },
      { id: 'MÊS', label: 'MÊS', checked: true },
      { id: 'CO_IBGE', label: 'CO_IBGE', checked: true },
      { id: 'NOME_DO_ENT', label: 'NOME_DO_ENT', checked: true },
      { id: 'SIGLA_ESTADO', label: 'SIGLA_ESTADO', checked: true },
      { id: 'COMPOSIÇÃO DA MASSA (A)', label: 'COMPOSIÇÃO DA MASSA (A)', checked: true },
      { id: 'TIPO DE FUNDO (B)', label: 'TIPO DE FUNDO (B)', checked: true },
      { id: 'CNPJ', label: 'CNPJ', checked: true },
      { id: 'NOME DO ÓRGÃO/ENTIDADE', label: 'NOME DO ÓRGÃO/ENTIDADE', checked: true },
      { id: 'PODER', label: 'PODER', checked: true },
      { id: 'TIPO_AUTARQUIA', label: 'TIPO_AUTARQUIA', checked: true },
      { id: 'CO_TIPO_POPULACAO', label: 'CO_TIPO_POPULACAO', checked: true },
      { id: 'TIPO_CARGO', label: 'TIPO_CARGO', checked: true },
      { id: 'CO_TIPO_APOSENTADORIA', label: 'CO_TIPO_APOSENTADORIA', checked: true },
      { id: 'MATRÍCULA', label: 'MATRÍCULA', checked: true },
      { id: 'CPF', label: 'CPF', checked: true },
      { id: 'PIS-PASEP', label: 'PIS-PASEP', checked: true },
      { id: 'SEXO DO APOSENTADO', label: 'SEXO DO APOSENTADO', checked: true },
      { id: 'ESTADO CIVIL', label: 'ESTADO CIVIL', checked: true },
      { id: 'DATA DE NASCIMENTO', label: 'DATA DE NASCIMENTO', checked: true },
      { id: 'DT_ING_SERV_PUB', label: 'DT_ING_SERV_PUB', checked: true },
      { id: 'DATA DE INGRESSO NO ENTE', label: 'DATA DE INGRESSO NO ENTE', checked: true },
      { id: 'DT_INICIO_APOSENTADORIA', label: 'DT_INICIO_APOSENTADORIA', checked: true },
      { id: 'VL_APOSENTADORIA', label: 'VL_APOSENTADORIA', checked: true },
      { id: 'VL_CONTRIBUICAO', label: 'VL_CONTRIBUICAO', checked: true },
      { id: 'VL_COMPENS_PREVID', label: 'VL_COMPENS_PREVID', checked: true },
      { id: 'IN_PARID_SERV', label: 'IN_PARID_SERV', checked: true },
      { id: 'CO_CONDICAO_APOSENTADO', label: 'CO_CONDICAO_APOSENTADO', checked: true },
      { id: 'NU_TEMPO_RGPS_MUN', label: 'NU_TEMPO_RGPS_MUN', checked: true },
      { id: 'NU_TEMPO_RPPS', label: 'NU_TEMPO_RPPS', checked: true },
      { id: 'NU_DEPENDENTES', label: 'NU_DEPENDENTES', checked: true },
      { id: 'DATA DE NASCIMENTO DO CÔNJUGE', label: 'DATA DE NASCIMENTO DO CÔNJUGE', checked: true },
      { id: 'CONDIÇÃO DO CÔNJUGE', label: 'CONDIÇÃO DO CÔNJUGE', checked: true },
      { id: 'DATA DE NASCIMENTO DO DEPENDENTE 2', label: 'DATA DE NASCIMENTO DO DEPENDENTE 2', checked: true },
      { id: 'CONDIÇÃO DO DEPENDENTE 2', label: 'CONDIÇÃO DO DEPENDENTE 2', checked: true },
      { id: 'DATA DE NASCIMENTO DO DEPENDENTE 3', label: 'DATA DE NASCIMENTO DO DEPENDENTE 3', checked: true },
      { id: 'CONDIÇÃO DO DEPENDENTE 3', label: 'CONDIÇÃO DO DEPENDENTE 3', checked: true },
      { id: 'PREVIDÊNCIA COMPLEMENTAR', label: 'PREVIDÊNCIA COMPLEMENTAR', checked: true },
      { id: 'TETO REMUNERATÓRIO ESPECÍFICO', label: 'TETO REMUNERATÓRIO ESPECÍFICO', checked: true }
    ];
  }

  async loadCidadeData() {
    const self = this;
    const responseCidade = await self.apiCall
      .get("enderecos/cidade?id=" + self.idCidade)
      .pipe(take(1))
      .toPromise();
    if (responseCidade && responseCidade[0]) {
      self.cidade = responseCidade[0];
    }
  }

  // Métodos para controlar seleção de campos
  selecionarTudo(tipo: string) {
    let campos = [];
    switch (tipo) {
      case 'sprev-ativos':
        campos = this.camposSPREVAtivos;
        break;
      case 'sprev-inativos':
        campos = this.camposSPREVInativos;
        break;
      case 'sprev-pensionistas':
        campos = this.camposSPREVPensionistas;
        break;
      case 'servidores':
        campos = this.camposServidores;
        break;
      case 'servidores-ativos':
        campos = this.camposServidoresAtivos;
        break;
      case 'servidores-inativos':
        campos = this.camposServidoresInativos;
        break;
      case 'servidores-pensionistas':
        campos = this.camposServidoresPensionistas;
        break;
      case 'tempo-servico':
        campos = this.camposTempoServico;
        break;
      case 'atendimentos':
        campos = this.camposAtendimentos;
        break;
      case 'pendencias':
        campos = this.camposPendencias;
        break;
    }

    const algumSelecionado = campos.some(campo => campo.checked);
    campos.forEach(campo => campo.checked = !algumSelecionado);
  }

  desmarcarTodos(tipo: string) {
    let campos = [];
    switch (tipo) {
      case 'sprev-ativos':
        campos = this.camposSPREVAtivos;
        break;
      case 'sprev-inativos':
        campos = this.camposSPREVInativos;
        break;
      case 'sprev-pensionistas':
        campos = this.camposSPREVPensionistas;
        break;
      case 'servidores':
        campos = this.camposServidores;
        break;
      case 'servidores-ativos':
        campos = this.camposServidoresAtivos;
        break;
      case 'servidores-inativos':
        campos = this.camposServidoresInativos;
        break;
      case 'servidores-pensionistas':
        campos = this.camposServidoresPensionistas;
        break;
      case 'tempo-servico':
        campos = this.camposTempoServico;
        break;
      case 'atendimentos':
        campos = this.camposAtendimentos;
        break;
      case 'pendencias':
        campos = this.camposPendencias;
        break;
    }

    campos.forEach(campo => campo.checked = false);
  }

  // Métodos de exportação
  abrirModalConfirmacao(content: any) {
    if (!this.exportarAtivos && !this.exportarInativos && !this.exportarPensionistas) {
      this.app.alert(
        "Atenção!",
        "Selecione pelo menos um tipo de relatório para exportar!",
        "error"
      );
      return;
    }
    this.modalService.open(content, { size: 'md', centered: true });
  }

  async confirmarExportacao(modal: any) {
    modal.close();
    await this.exportarSPREV();
  }

  async exportarSPREV() {
    const self = this;
    if (!self.idCidade) {
      return;
    }

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const servidores = await this.apiCall
        .get(`servidor/relatorio/brprev?id_cidade=${self.idCidade}`)
        .pipe(take(1))
        .toPromise();

      if (!servidores) {
        this.spinner.hide();
        return;
      }

      let servidoresPorAno = servidores.filter((s) => s.status != 5);

      if (this.exportarAtivos) {
        await this.exportarServidoresAtivos(servidoresPorAno);
      }

      if (this.exportarInativos) {
        await this.exportarServidoresInativos(servidoresPorAno);
      }

      if (this.exportarPensionistas) {
        await this.exportarServidoresPensionistas(servidoresPorAno);
      }

      await this.app.alert(
        "Sucesso!",
        "Relatórios exportados com sucesso!",
        "success"
      );

    } catch (error) {
      await this.app.alert(
        "Erro!",
        "Erro ao exportar relatórios. Tente novamente.",
        "error"
      );
    }

    this.spinner.hide();
  }

  async exportarServidoresAtivos(servidores: any[]) {
    const servidoresAtivos = [];
    
    for (let servidor of servidores) {
      if (servidor.status !== null && servidor.status == 1) {
        const recenseado = servidor.inicio_atendimento ? "Sim" : "Não";
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENTE": servidor.nome_cidade,
          "SIGLA_ESTADO": servidor.estado_naturalidade,
          "COMPOSIÇÃO DA MASSA (A)": "1",
          "TIPO DO FUNDO (B)": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          PODER: servidor.poder == null || servidor.poder == undefined ? "" : servidor.poder,
          TIPO: servidor.administracao == null || servidor.administracao == undefined ? "" : servidor.administracao,
          "A - POPULAÇÃO COBERTA": servidor.carreira == '21' ? "Militares em atividade" : "Ativos",
          "B- POPULAÇÃO COBERTA": servidor.carreira,
          "C - POPULAÇÃO COBERTA": servidor.populacao_coberta_c,
          Matrícula: servidor.matricula,
          CPF: servidor.cpf,
          "PIS-PASEP": servidor.pis,
          SEXO: servidor.sexo,
          "ESTADO CIVIL": servidor.estadoCivil,
          "DATA DE NASCIMENTO": servidor.dataNascimento,
          "COD SITUAÇÃO FUNCIONAL": servidor.situacao_funcional,
          "TIPO DE VÍNCULO": "1",
          "DATA DE INGRESSO NO SERV_PUBLICO": servidor.data_ingresso_serv,
          "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
          "DATA DE INGRESSO NA CARREIRA ATUAL": servidor.dataIngressoCarreiraAtual,
          "IDENTIFICAÇÃO DA CARREIRA ATUAL": servidor.carreiraAtual,
          "DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL": servidor.dataInicioCargoAtual,
          "IDENTIFICAÇÃO DO CARGO ATUAL": servidor.cargoAtual,
          "BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": servidor.salarioBaseMensal,
          "REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO": servidor.salarioTotal,
          "CONTRIBUIÇÃO MENSAL": "",
          "PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": "",
          "TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS": servidor.tempoServicoAnteriorTotal,
          "NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO": servidor.totalDependentes,
          "DATA DE NASCIMENTO DO CÔNJUGE OU COMPANHEIRO(A)": servidor.dataNascimentoConjugeOuCompanheiroAtivo,
          "CONDIÇÃO DO CÔNJUGE": "1",
          "DATA DE NASCIMENTO DO DEPENDENTE 2": servidor.dataNascimentoDependente2Ativo,
          "CONDIÇÃO DO DEPENDENTE 2": "1",
          "DATA DE NASCIMENTO DO DEPENDENTE 3": servidor.dataNascimentoDependente3Ativo,
          "CONDIÇÃO DO DEPENDENTE 3": "1",
          "SEGURADO EM ABONO DE PERMANÊNCIA ": servidor.abono_permanencia,
          "DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO": servidor.data_abono,
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
          "RECENSEADO": recenseado,
        };

        const newData = {};
        for (const campo of this.camposSPREVAtivos) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresAtivos.push(newData);
      }
    }

    if (servidoresAtivos.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresAtivos)),
        "servidores_ativos_sprev"
      );
    }
  }

  async exportarServidoresInativos(servidores: any[]) {
    const servidoresInativos = [];
    
    for (let servidor of servidores) {
      if (servidor.status == 2 || servidor.status == null) {
        const recenseado = servidor.inicio_atendimento && servidor.fim_atendimento ? "Sim" : "Não";
        const tipoCargo = servidor.tipo_aposentadoria == 2 ? 2 : 7;
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENT": servidor.nome_cidade,
          "SIGLA_ESTADO": servidor.estado_naturalidade,
          "COMPOSIÇÃO DA MASSA (A)": "1",
          "TIPO DE FUNDO (B)": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          PODER: servidor.poder == null || servidor.poder == undefined ? "" : servidor.poder,
          "CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)": servidor.administracao == null || servidor.administracao == undefined ? "" : servidor.administracao,
          "TIPO_AUTARQUIA": servidor.administracao == null || servidor.administracao == undefined ? "" : servidor.administracao,
          "CO_TIPO_POPULACAO": 4,
          "TIPO_CARGO": tipoCargo,
          "CO_TIPO_APOSENTADORIA":
            servidor.tipo_aposentadoria == null || servidor.tipo_aposentadoria == undefined
              ? ""
              : servidor.tipo_aposentadoria,
          MATRÍCULA: servidor.matricula,
          CPF: servidor.cpf,
          "PIS-PASEP": servidor.pis,
          "SEXO DO APOSENTADO": servidor.sexo,
          "ESTADO CIVIL": servidor.estadoCivil,
          "DATA DE NASCIMENTO": servidor.dataNascimento,
          "DT_ING_SERV_PUB": servidor.data_ingresso_serv,
          "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
          "DT_INICIO_APOSENTADORIA": servidor.concessao_aposentadoria,
          "VL_APOSENTADORIA": servidor.salarioBaseMensal,
          "VL_CONTRIBUICAO": "",
          "VL_COMPENS_PREVID": "",
          "IN_PARID_SERV": servidor.paridade_aposentadoria,
          "CO_CONDICAO_APOSENTADO": servidor.deficiente,
          "NU_TEMPO_RGPS_MUN": servidor.tempoServicoAnteriorTotal,
          "NU_TEMPO_RPPS": "",
          "NU_DEPENDENTES": servidor.totalDependentes,
          "DATA DE NASCIMENTO DO CÔNJUGE": servidor.dataNascimentoConjuge,
          "CONDIÇÃO DO CÔNJUGE": "1",
          "DATA DE NASCIMENTO DO DEPENDENTE 2": servidor.dataNascimentoDependente2,
          "CONDIÇÃO DO DEPENDENTE 2": "1",
          "DATA DE NASCIMENTO DO DEPENDENTE 3": servidor.dataNascimentoDependente3,
          "CONDIÇÃO DO DEPENDENTE 3": "1",
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
          "RECENSEADO": recenseado,
        };

        const newData = {};
        for (const campo of this.camposSPREVInativos) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresInativos.push(newData);
      }
    }

    if (servidoresInativos.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresInativos)),
        "servidores_inativos_sprev"
      );
    }
  }

  async exportarServidoresPensionistas(servidores: any[]) {
    const servidoresPensionistas = [];
    
    for (let servidor of servidores) {
      if (servidor.status !== null && servidor.status == 3) {
        const recenseado = servidor.inicio_atendimento && servidor.fim_atendimento ? "Sim" : "Não";
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENTE": servidor.nome_cidade,
          "SG_UF": servidor.estado_naturalidade,
          "CO_COMP_MASSA": "1",
          "CO_TIPO_FUNDO": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          "CO_PODER (CÓDIGO DO PODER)": servidor.poder,
          "CO_TIPO_PODER (CÓDIGO DO TIPO DE PODER)": servidor.administracao,
          "CO_TIPO_INSTITUIDOR (CÓDIGO DO TIPO DE INSTITUIDOR)": servidor.administracao,
          "ID MATRICULA INSTITUIDOR": servidor.matricula_pensao,
          "INSTITUIDOR CPF": servidor.cpf_pensao,
          "INSTITUIDOR PIS PASEP": servidor.pis_pensao,
          "SEXO INSTITUIDOR": servidor.sexo_instituidor || "",
          "DT_NASC_INSTITUIDOR": servidor.data_nascimento_pensao,
          "DT_OBITO_INSTITUIDOR": servidor.data_falecimento_pensao,
          "MATRICULA_PENSIONISTA": servidor.matricula,
          "CPF_PENSIONISTA": servidor.cpf,
          "SEXO": servidor.sexo,
          "DT_NASC_PENSIONISTA": servidor.dataNascimento,
          "RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR": servidor.relacao_titular_pensao,
          "DATA INICIO PENSAO": servidor.concessao_aposentadoria,
          "VALOR BENEF PENSAO": servidor.salarioBaseMensal,
          "VALOR TOTAL DA PENSÃO": servidor.salarioBaseMensal,
          "VL_PCT_QUOTA": "",
          "VALOR CONTRIBUICAO": "",
          "VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA": "",
          "PARIDADE": servidor.paridade_aposentadoria,
          "CONDIÇÃO DO PENSIONISTA": servidor.deficiente,
          "DURAÇÃO DO BENEFÍCIO": servidor.tipo_pensao,
          "TEMPO DURAÇÃO DO BENEFÍCIO": "",
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
          "RECENSEADO": recenseado,
        };

        const newData = {};
        for (const campo of this.camposSPREVPensionistas) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresPensionistas.push(newData);
      }
    }

    if (servidoresPensionistas.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresPensionistas)),
        "servidores_pensionistas_sprev"
      );
    }
  }

  // Métodos para outros relatórios (baseados nos componentes existentes)
  async exportarRelatorio(tipo: string) {
    const self = this;
    if (!self.idCidade) {
      return;
    }

    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      let dados = [];
      let campos = [];
      let nomeArquivo = '';

      switch (tipo) {
        case 'servidores':
          await this.exportarServidoresTresBases();
          this.spinner.hide();
          await this.app.alert(
            "Sucesso!",
            "Relatórios exportados com sucesso!",
            "success"
          );
          return;
        case 'servidores-ativos':
          await this.exportarBancoDeDadosAtivos();
          await this.app.alert(
            "Sucesso!",
            "Relatório exportado com sucesso!",
            "success"
          );
          return;
        case 'servidores-inativos':
          await this.exportarBancoDeDadosInativos();
          await this.app.alert(
            "Sucesso!",
            "Relatório exportado com sucesso!",
            "success"
          );
          return;
        case 'servidores-pensionistas':
          await this.exportarBancoDeDadosPensionistas();
          await this.app.alert(
            "Sucesso!",
            "Relatório exportado com sucesso!",
            "success"
          );
          return;
        case 'tempo-servico':
          dados = await this.getDadosTempoServico();
          campos = this.camposTempoServico;
          nomeArquivo = 'tempo_servico_passado';
          break;
        case 'atendimentos':
          dados = await this.getDadosAtendimentos();
          campos = this.camposAtendimentos;
          nomeArquivo = 'servidores_atendimento';
          break;
        case 'pendencias':
          dados = await this.getDadosPendencias();
          campos = this.camposPendencias;
          nomeArquivo = 'pendencias';
          break;
      }

      // Filtrar dados baseado nos campos selecionados
      const dadosFiltrados = dados.map(item => {
        const newItem = {};
        for (const campo of campos) {
          if (campo.checked) {
            newItem[campo.id] = item[campo.id];
          }
        }
        return newItem;
      });

      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(dadosFiltrados)),
        nomeArquivo
      );

      await this.app.alert(
        "Sucesso!",
        "Relatório exportado com sucesso!",
        "success"
      );

    } catch (error) {
      await this.app.alert(
        "Erro!",
        "Erro ao exportar relatório. Tente novamente.",
        "error"
      );
    }

    this.spinner.hide();
  }

  async exportarServidoresTresBases() {
    const self = this;
    let servidoresAtivos = [];
    let servidoresPensionistas = [];
    let servidoresInativos = [];

    const servidores = await this.apiCall
      .get("servidor/relatorio/cidade?id_cidade=" + this.idCidade)
      .pipe(take(1))
      .toPromise();

    if (!servidores) {
      return;
    }

    for (let servidor of servidores) {
      // Ativos
      if (servidor.status == "1") {
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade || servidor.nome_cidade,
          SG_UF: servidor.estado || servidor.estado_naturalidade,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: servidor.fundo || "1",
          CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder || "",
          CO_TIPO_PODER: servidor.tipo_poder || "",
          CO_TIPO_INSTITUIDOR: servidor.administracao || "",
          ID_INSTITUIDOR_MATRICULA: servidor.matricula_pensao || "",
          ID_INSTITUIDOR_CPF: servidor.cpf_pensao || "",
          ID_INSTITUIDOR_PIS_PASEP: servidor.pis_pensao || "",
          ID_PENSIONISTA_CPF: servidor.cpf,
          CO_SEXO_PENSIONISTA: servidor.sexo,
          DT_NASC_PENSIONISTA: servidor.dataNascimento,
          DT_INICIO_PENSAO: servidor.dataIngressoCarreiraAtual || servidor.concessao_aposentadoria || "",
          VL_BENEF_PENSAO: servidor.salarioBaseMensal || servidor.salarioTotal || "",
          VL_CONTRIBUICAO: "",
          VL_COMPENS_PREVID: "",
          IN_PARID_SERV: servidor.paridade_aposentadoria || "",
          CO_CONDICAO: servidor.deficiente || "",
          CO_DURACAO: servidor.tipo_pensao || "",
        };

        const newData = {};
        for (const campo of this.camposServidores) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresAtivos.push(newData);
      }
      // Pensionistas
      else if (servidor.status == "3") {
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade || servidor.nome_cidade,
          SG_UF: servidor.estado || servidor.estado_naturalidade,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: servidor.fundo || "1",
          CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder || "",
          CO_TIPO_PODER: servidor.tipo_poder || "",
          CO_TIPO_INSTITUIDOR: servidor.administracao || "",
          ID_INSTITUIDOR_MATRICULA: servidor.matricula_pensao || "",
          ID_INSTITUIDOR_CPF: servidor.cpf_pensao || "",
          ID_INSTITUIDOR_PIS_PASEP: servidor.pis_pensao || "",
          ID_PENSIONISTA_CPF: servidor.cpf,
          CO_SEXO_PENSIONISTA: servidor.sexo,
          DT_NASC_PENSIONISTA: servidor.dataNascimento,
          DT_INICIO_PENSAO: servidor.concessao_aposentadoria || servidor.dataIngressoCarreiraAtual || "",
          VL_BENEF_PENSAO: servidor.salarioBaseMensal || servidor.salarioTotal || "",
          VL_CONTRIBUICAO: "",
          VL_COMPENS_PREVID: "",
          IN_PARID_SERV: servidor.paridade_aposentadoria || "",
          CO_CONDICAO: servidor.deficiente || "",
          CO_DURACAO: servidor.tipo_pensao || "",
        };

        const newData = {};
        for (const campo of this.camposServidores) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresPensionistas.push(newData);
      }
      // Inativos
      else if (servidor.status == "2" || servidor.status == null) {
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade || servidor.nome_cidade,
          SG_UF: servidor.estado || servidor.estado_naturalidade,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: servidor.fundo || "1",
          CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder || "",
          CO_TIPO_PODER: servidor.tipo_poder || "",
          CO_TIPO_INSTITUIDOR: servidor.administracao || "",
          ID_INSTITUIDOR_MATRICULA: servidor.matricula_pensao || "",
          ID_INSTITUIDOR_CPF: servidor.cpf_pensao || "",
          ID_INSTITUIDOR_PIS_PASEP: servidor.pis_pensao || "",
          ID_PENSIONISTA_CPF: servidor.cpf,
          CO_SEXO_PENSIONISTA: servidor.sexo,
          DT_NASC_PENSIONISTA: servidor.dataNascimento,
          DT_INICIO_PENSAO: servidor.concessao_aposentadoria || servidor.dataIngressoCarreiraAtual || "",
          VL_BENEF_PENSAO: servidor.salarioBaseMensal || servidor.salarioTotal || "",
          VL_CONTRIBUICAO: "",
          VL_COMPENS_PREVID: "",
          IN_PARID_SERV: servidor.paridade_aposentadoria || "",
          CO_CONDICAO: servidor.deficiente || "",
          CO_DURACAO: servidor.tipo_pensao || "",
        };

        const newData = {};
        for (const campo of this.camposServidores) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        servidoresInativos.push(newData);
      }
    }

    // Exportar as 3 bases
    if (servidoresAtivos.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresAtivos)),
        "servidores_ativos"
      );
    }

    if (servidoresPensionistas.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresPensionistas)),
        "servidores_pensionistas"
      );
    }

    if (servidoresInativos.length > 0) {
      this.excelService.exportAsExcelFile(
        JSON.parse(JSON.stringify(servidoresInativos)),
        "servidores_inativos"
      );
    }
  }

  async getDadosServidores() {
    const servidores = await this.apiCall
      .get("servidor/relatorio/cidade?id_cidade=" + this.idCidade)
      .pipe(take(1))
      .toPromise();
    
    return servidores || [];
  }

  async getDadosTempoServico() {
    const tempos = await this.apiCall
      .get("servidor/relatorio/tempo?id_cidade=" + this.idCidade)
      .pipe(take(1))
      .toPromise();
    
    return tempos || [];
  }

  async getDadosAtendimentos() {
    const atendimentos = await this.apiCall
      .get("servidor/atendimento/relatorio?id_cidade=" + this.idCidade)
      .pipe(take(1))
      .toPromise();
    
    return atendimentos || [];
  }

  async getDadosPendencias() {
    const servidores = await this.apiCall
      .get("servidor/relatorio/cidade/pendencias?id_cidade=" + this.idCidade)
      .pipe(take(1))
      .toPromise();
    
    const lista = [];
    for (let servidor of servidores || []) {
      if (servidor.pendencias) {
        lista.push({
          NOME: servidor.nome,
          STATUS: servidor.statusServidor == "1" || servidor.status == "1" ? "Ativo" :
                 servidor.statusServidor == "4" || servidor.status == "3" ? "Pensionista" :
                 servidor.statusServidor == "3" || servidor.status == "2" ? "Aposentado" :
                 servidor.status == "4" ? "Exonerado" : "",
          PENDÊNCIA: servidor.pendencias,
          OBSERVAÇÃO: servidor.observacoes,
        });
      }
    }
    
    return lista;
  }

  // Métodos de exportação dinâmica (baseados no relatorios-dinamico)
  async exportarBancoDeDadosAtivos() {
    const self = this;
    if (!self.idCidade) {
      return;
    }
    
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    const servidores = await this.apiCall
      .get(`servidor/relatorio/brprev?id_cidade=${self.idCidade}`)
      .pipe(take(1))
      .toPromise();
    
    if (!servidores) {
      this.spinner.hide();
      return;
    }
    
    self.servidoresAtivos = [];
    let servidoresPorAno = servidores.filter((s) => s.status != 5);
    
    for (let servidor of servidoresPorAno) {
      if (servidor.status !== null && servidor.status == 1) {
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENTE": servidor.nome_cidade,
          "SIGLA_ESTADO": servidor.estado_naturalidade,
          "COMPOSIÇÃO DA MASSA (A)": "1",
          "TIPO DO FUNDO (B)": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          PODER: servidor.poder == null || servidor.poder == undefined ? "" : servidor.poder,
          TIPO: servidor.administracao == null || servidor.administracao == undefined ? "" : servidor.administracao,
          "A - POPULAÇÃO COBERTA": servidor.carreira == '21' ? "Militares em atividade" : "Ativos",
          "B- POPULAÇÃO COBERTA": servidor.carreira,
          "C - POPULAÇÃO COBERTA": servidor.populacao_coberta_c,
          MATRÍCULA: servidor.matricula,
          CPF: servidor.cpf,
          "PASEP": servidor.pis,
          SEXO: servidor.sexo,
          "ESTADO CIVIL": servidor.estadoCivil,
          "DATA DE NASCIMENTO": servidor.dataNascimento,
          "COD SITUAÇÃO FUNCIONA": "",
          "TIPO DE VÍNCULO": "",
          "DATA DE INGRESSO NO SERV_PUBLICO": servidor.data_ingresso_serv,
          "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
          "DATA DE INGRESSO NA CARREIRA ATUAL": servidor.dataIngressoCarreiraAtual,
          "IDENTIFICAÇÃO DA CARREIRA ATUAL": servidor.carreiraAtual,
          "DATA DE INÍCIO DE EXERCÍCIO NO CARGO ATUAL": servidor.dataInicioCargoAtual,
          "IDENTIFICAÇÃO DO CARGO ATUAL": servidor.cargoAtual,
          "BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": servidor.salarioBaseMensal,
          "REMUNERAÇÃO MENSAL TOTAL DO SERVIDOR ATIVO": servidor.salarioTotal,
          "CONTRIBUIÇÃO MENSAL": "",
          "PRIMEIRA BASE DE CÁLCULO MENSAL DO SERVIDOR ATIVO": "",
          "TEMPO DE CONTRIBUIÇÃO DO SERVIDOR ATIVO ANTERIOR À ADMISSÃO NO ENTE PARA O RGPS": servidor.tempoServicoAnteriorTotal,
          "NÚMERO DE DEPENDENTES DO SERVIDOR ATIVO": servidor.totalDependentes,
          "CONDIÇÃO DO CÔNJUGE": "",
          "DATA DE NASCIMENTO DO DEPENDENTE 2": servidor.dataNascimentoDependente2,
          "CONDIÇÃO DO DEPENDENTE 2": "",
          "DATA DE NASCIMENTO DO DEPENDENTE 3": servidor.dataNascimentoDependente3,
          "CONDIÇÃO DO DEPENDENTE 3": "",
          "SEGURADO EM ABONO DE PERMANÊNCIA": servidor.abono_permanencia,
          "DATA DE INÍCIO DE ABONO DE PERMANÊNCIA DO SERVIDOR ATIVO": servidor.data_abono,
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
        };

        const newData = {};
        for (const campo of this.camposServidoresAtivos) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        self.servidoresAtivos.push(newData);
      }
    }
    
    this.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(this.servidoresAtivos)),
      "servidoresativos"
    );
    
    this.spinner.hide();
  }

  async exportarBancoDeDadosInativos() {
    const self = this;
    if (!self.idCidade) {
      return;
    }
    
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    const servidores = await this.apiCall
      .get(`servidor/relatorio/brprev?id_cidade=${self.idCidade}`)
      .pipe(take(1))
      .toPromise();
    
    if (!servidores) {
      this.spinner.hide();
      return;
    }
    
    self.servidoresInativos = [];
    let servidoresPorAno = servidores.filter((s) => s.status != 5);
    
    for (let servidor of servidoresPorAno) {
      if (servidor.status == 2 || servidor.status == null) {
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENT": servidor.nome_cidade,
          "SIGLA_ESTADO": servidor.estado_naturalidade,
          "COMPOSIÇÃO DA MASSA (A)": "1",
          "TIPO DE FUNDO (B)": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          PODER: servidor.poder == null || servidor.poder == undefined ? "" : servidor.poder,
          "TIPO_AUTARQUIA": servidor.administracao,
          "CO_TIPO_POPULACAO": servidor.co_tipo_populacao,
          "TIPO_CARGO": servidor.tipo_cargo,
          "CO_TIPO_APOSENTADORIA": servidor.tipo_aposentadoria == null || servidor.tipo_aposentadoria == undefined ? "" : servidor.tipo_aposentadoria,
          "MATRÍCULA": servidor.matricula,
          "CPF": servidor.cpf,
          "PIS-PASEP": servidor.pis,
          "SEXO DO APOSENTADO": servidor.sexo,
          "ESTADO CIVIL": servidor.estadoCivil,
          "DATA DE NASCIMENTO": servidor.dataNascimento,
          "DT_ING_SERV_PUB": servidor.data_ingresso_serv,
          "DATA DE INGRESSO NO ENTE": servidor.dataIngressoEnte,
          "DT_INICIO_APOSENTADORIA": servidor.concessao_aposentadoria,
          "VL_APOSENTADORIA": servidor.salarioBaseMensal,
          "VL_CONTRIBUICAO": "",
          "VL_COMPENS_PREVID": "",
          "IN_PARID_SERV": servidor.paridade_aposentadoria,
          "CO_CONDICAO_APOSENTADO": servidor.deficiente,
          "NU_TEMPO_RGPS_MUN": "",
          "NU_TEMPO_RPPS": "",
          "NU_DEPENDENTES": servidor.totalDependentes,
          "DATA DE NASCIMENTO DO CÔNJUGE": servidor.dataNascimentoConjuge,
          "CONDIÇÃO DO CÔNJUGE": "",
          "DATA DE NASCIMENTO DO DEPENDENTE 2": servidor.dataNascimentoDependente2,
          "CONDIÇÃO DO DEPENDENTE 2": "",
          "DATA DE NASCIMENTO DO DEPENDENTE 3": servidor.dataNascimentoDependente3,
          "CONDIÇÃO DO DEPENDENTE 3": "",
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
        };

        const newData = {};
        for (const campo of this.camposServidoresInativos) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        self.servidoresInativos.push(newData);
      }
    }
    
    this.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(this.servidoresInativos)),
      "servidoresinativos"
    );
    
    this.spinner.hide();
  }

  async exportarBancoDeDadosPensionistas() {
    const self = this;
    if (!self.idCidade) {
      return;
    }
    
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    
    const servidores = await this.apiCall
      .get(`servidor/relatorio/brprev?id_cidade=${self.idCidade}`)
      .pipe(take(1))
      .toPromise();
    
    if (!servidores) {
      this.spinner.hide();
      return;
    }
    
    self.servidoresPensionistas = [];
    let servidoresPorAno = servidores.filter((s) => s.status != 5);
    
    for (let servidor of servidoresPorAno) {
      if (servidor.status !== null && servidor.status == 3) {
        let data = {
          NOME: servidor.nome,
          ANO: servidor.ano,
          MÊS: servidor.mes,
          "CO_IBGE": servidor.ibge,
          "NOME_DO_ENTE": servidor.nome_cidade,
          "SG_UF": servidor.estado_naturalidade,
          "CO_COMP_MASSA": "1",
          "CO_TIPO_FUNDO": servidor.fundo,
          CNPJ: servidor.cnpj,
          "NOME DO ÓRGÃO/ENTIDADE": servidor.orgao,
          "CO_PODER": servidor.poder,
          "CO_TIPO_PODER": servidor.tipo_poder,
          "CO_TIPO_INSTITUIDOR": servidor.administracao,
          "ID MATRICULA INSTITUIDOR": servidor.matricula_pensao,
          "INSTITUIDOR CPF": servidor.cpf_pensao,
          "INSTITUIDOR PIS PASEP": servidor.pis_pensao,
          "SEXO INSTITUIDOR": servidor.sexo_instituidor || "",
          "DT_NASC_INSTITUIDOR": servidor.data_nascimento_pensao,
          "DT_OBITO_INSTITUIDOR": servidor.data_falecimento_pensao,
          "MATRICULA_PENSIONISTA": servidor.matricula,
          "CPF_PENSIONISTA": servidor.cpf,
          "SEXO": servidor.sexo,
          "DT_NASC_PENSIONISTA": servidor.dataNascimento,
          "RELAÇÃO DO PENSIONISTA COM O INSTITUIDOR": servidor.relacao_titular_pensao,
          "DATA INICIO PENSAO": servidor.concessao_aposentadoria,
          "VALOR BENEF PENSAO": servidor.salarioBaseMensal,
          "VALOR TOTAL DA PENSÃO": servidor.salarioBaseMensal,
          "VL_PCT_QUOTA": "",
          "VALOR CONTRIBUICAO": "",
          "VALOR MENSAL DA COMPENSAÇÃO PREVIDENCIÁRIA": "",
          "PARIDADE": servidor.paridade_aposentadoria,
          "CONDIÇÃO DO PENSIONISTA": servidor.deficiente,
          "DURAÇÃO DO BENEFÍCIO": servidor.tipo_pensao,
          "TEMPO DURAÇÃO DO BENEFÍCIO": "",
          "PREVIDÊNCIA COMPLEMENTAR": "",
          "TETO REMUNERATÓRIO ESPECÍFICO": "",
        };

        const newData = {};
        for (const campo of this.camposServidoresPensionistas) {
          if (campo.checked) {
            newData[campo.id] = data[campo.id];
          }
        }
        self.servidoresPensionistas.push(newData);
      }
    }
    
    this.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(this.servidoresPensionistas)),
      "servidorespensionistas"
    );
    
    this.spinner.hide();
  }
}
